import React, { useMemo, useEffect } from 'react';
import { connect } from 'react-redux';
import { Container, Row, Col } from 'reactstrap';
import { pages, otpValidationPopupContent, customerTypeEnum, popupReasonEnum, lobbyTabsEnum, saleOTPSteps } from '../cellcomAbroadVariables';
import {
  removeOtpData,
  closeModal,
  openModal,
  setActiveLobbyTab,
  returnToLobby,
  setRemoveToCustomerSurfingBlockage,
  setReadyToPurchase,
  saveToHistory,
  setSelectedAbroadPackage,
  setReadyToPurchaseFamily,
  setIsSelectingAccountBusinessIndividual,
  setSearchedPackages,
  setLoading,
  setFlightManager,
  setSaleOtpStep,
} from '../cellcomAbroadBlockSlice';
import { getFilteredCountryList, isSuitableDates } from '../cellcomAbroadUtilities';
import PopupHeadlineComponent from './PopupSharedComponents/PopupHeadlineComponent';
import PopupDescriptionComponent from './PopupSharedComponents/PopupDescriptionComponent';
import WarningMessageComponent from '../Shared/Components/Warning/WarningMessageComponent';
import PopupImageComponent from './PopupSharedComponents/PopupImageComponent';
import PopupSubTitleComponent from './PopupSharedComponents/PopupSubTitleComponent';
import CallBackComponent from './PopupSharedComponents/CallBackComponent';
import PopupDefaultPackageDataComponent from './PopupDefaultPackageDataComponent';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import PopupButtonAsLinkComponent from './PopupSharedComponents/PopupButtonAsLinkComponent';
import AbroadPackageTab from '../Shared/Components/AbroadPackageTab';
import gaParams from '../../../../utilities/analytics/constants';
import { gaEvent, gtag4 } from '../../../../utilities/analytics/tracking';
import { report, getReportParams } from '../../../../middleware/report';
import Lottie from 'react-lottie';
import PaperPlane from '../../../../animations/paperPlane.json';
import ThemedLottie from '../../../Shared/ThemedLottie/ThemedLottie';
import { ThemeColorEnum } from '../../../../utilities/theme/ThemeColorEnum';
import BtnWhite from '../../../Shared/Buttons/BtnWhite';
import { isIOS } from 'react-device-detect';
import { gaPricePlanVoiceExistsButtonClick, gaCustomerGoldClassButtonClick } from '../../AbroadBusinessIndividualBlock/GaReports';
import { gaDefaultPackageContinueWithSelected, gaSockRoamButtonClick, gaChangeAccountAutoPackage } from './../gaReports';
import { resetAuth, resetLoginData } from '../../../../utilities/authentication/authenticationSlice';
const OtpValidationResultPopupConstructor = (props) => {
  if (!props.popupData?.id) {
    return null;
  }
  let currentPopupContent = useMemo(() => {
    return getPopupContent();
  }, []);
  useEffect(() => {
    if (
      (props.popupData.id == 'isNotCellcomAccount' ||
        props.popupData.id == 'subStatusIsA' ||
        props.popupData.id == 'talkmanAccount' ||
        props.popupData.id == 'dummySubIndIsNull' ||
        props.popupData.id == 'rollingPackageExists' ||
        props.popupData.id == 'cantPurchasePackage' ||
        props.popupData.id == 'abroadIsClosedForAccount' ||
        props.popupData.id == 'unableToViewInformation' ||
        props.popupData.id == 'otpGeneralError' ||
        props.popupData.id == 'separatedSaleRollingPackage' ||
        props.popupData.id == 'separatedSaleAutoPackage') &&
      !props.data.isJETAuthentication &&
      !props.data.epiStyleInitializationData.businessIndividualLobby &&
      !props.authentication.loginData.isFullAuthenticated &&
      !props.data.otpData?.isFamilyProcess
    ) {
      logoutAccount();
    }
  }, [props.popupData.id]);

  const logoutAccount = () => {
    //props.resetAuth();
    props.resetLoginData();
    props.removeOtpData();
    props.saveToHistory();
  };

  const returnToAbroadLobby = () => {
    const businessOrPrivate =
      props.data.otpData.validatedCostumerData?.accountType == customerTypeEnum.BUSINESS
        ? customerTypeEnum.BUSINESS
        : customerTypeEnum.PRIVATE;
    let activeTab = lobbyTabsEnum.PACKAGEEXISTS;
    let executePackagesSearch = false;
    let approvedPopup = false;
    let lobbyPath = props.lobbyPath ? props.lobbyPath : props.data.epiStyleInitializationData.currentLobbyPath;

    switch (props.popupData?.id) {
      case otpValidationPopupContent.autoPackageExists.id:
        gaEvent(
          gaParams.ABROAD_LOBBY_OTP_VALIDATION_AUTO_PACKAGE_POPUP_BUTTON_CLICK_BUSINESS.category,
          gaParams.ABROAD_LOBBY_OTP_VALIDATION_AUTO_PACKAGE_POPUP_BUTTON_CLICK_BUSINESS.eventType,
          gaParams.ABROAD_LOBBY_OTP_VALIDATION_AUTO_PACKAGE_POPUP_BUTTON_CLICK_BUSINESS.eventParams,
        );
        break;
      case otpValidationPopupContent.autoPackageExistsBusinessIndividual.id:
        activeTab = lobbyTabsEnum.PACKAGEEXISTS_BUSINESSINDIVIDUAL;
        gaEvent(
          gaParams.ABROAD_BUSINESS_INDIVIDUAL_TICKET_AUTO_PACKAGE_POPUP_BUTTON.category,
          gaParams.ABROAD_BUSINESS_INDIVIDUAL_TICKET_AUTO_PACKAGE_POPUP_BUTTON.eventType,
          props.popupData.buttonText,
        );
        break;
      case otpValidationPopupContent.isBusinessAccount.id:
      case otpValidationPopupContent.isBusinessAccountInfo.id:
        activeTab = lobbyTabsEnum.BUSINESSACCOUNT;
        if (props.data.startedFromPackage) {
          gaEvent(
            gaParams.ABROAD_TICKET_OTP_VALIDATION_IS_BUSINESS_ACCOUNT_BUTTON_ACTION_PRIVATE_FROM_PACKAGE.category,
            gaParams.ABROAD_TICKET_OTP_VALIDATION_IS_BUSINESS_ACCOUNT_BUTTON_ACTION_PRIVATE_FROM_PACKAGE.eventType,
          );
        } else {
          gtag4({
            event: 'CellcomAbroad_Step11_BusinessPackagesButton',
            button: 'עבור_לחבילות_עסקיות',
            step: '11',
            action: 'BusinessPackagesButton',
            process_type: 'private',
            funnel_name: '2 - SearchArea',
          });
        }
        break;
      case otpValidationPopupContent.isCellcomWorkerOtpSale.id:
        activeTab = lobbyTabsEnum.BUSINESSACCOUNT;
        if (props.data.startedFromPackage) {
          gaEvent(
            gaParams.ABROAD_TICKET_OTP_VALIDATION_IS_CELLCOM_WORKER_BUTTON_ACTION_PRIVATE_FROM_PACKAGE.category,
            gaParams.ABROAD_TICKET_OTP_VALIDATION_IS_CELLCOM_WORKER_BUTTON_ACTION_PRIVATE_FROM_PACKAGE.eventType,
            'עבור_לחבילות_עסקיות',
          );
        } else {
          gaEvent(
            gaParams.ABROAD_TICKET_OTP_VALIDATION_IS_CELLCOM_WORKER_BUTTON_ACTION_PRIVATE.category,
            gaParams.ABROAD_TICKET_OTP_VALIDATION_IS_CELLCOM_WORKER_BUTTON_ACTION_PRIVATE.eventType,
            'עבור_לחבילות_עסקיות',
          );
        }
        break;
      case otpValidationPopupContent.isCellcomWorkerOtpSaleFamily.id:
        activeTab = lobbyTabsEnum.BUSINESSACCOUNT;
        break;
      case otpValidationPopupContent.defaultPackageExists.id:
        if (businessOrPrivate == customerTypeEnum.PRIVATE) {
          if (props.data.startedFromPackage) {
            gtag4({
              event: 'CellcomAbroad_Step10_DefaultPackageClickButton',
              step: '10',
              action: 'DefaultPackageClickButton',
              process_type: 'private',
              funnel_name: '3 - Package',
              button: 'להישאר עם החבילה שכבר יש לי',
            });
          } else {
            gtag4({
              event: 'CellcomAbroad_Step13_DefaultPackageClickButton',
              step: '13',
              action: 'DefaultPackageClickButton',
              process_type: 'private',
              funnel_name: '2 - SearchArea',
              button: 'להישאר עם החבילה שכבר יש לי',
            });
          }
        } else {
          if (!props.data.startedFromPackage) {
            gtag4({
              event: 'CellcomAbroad_Step7_DefaultRoamingPackageButton',
              step: '7',
              button: 'להישאר עם החבילה שכבר יש לי',
              action: 'DefaultRoamingPackageButton',
              process_type: 'business',
              funnel_name: '1 - Lobby - Business',
            });
          }
        }
        break;
      case otpValidationPopupContent.abroadIsClosedForAccountSeparatedBank.id:
      case otpValidationPopupContent.abroadIsClosedForAccountSeparatedByUse.id:
      case otpValidationPopupContent.separatedGeneralError.id:
      case otpValidationPopupContent.separatedNoShadowSoc.id:
      case otpValidationPopupContent.separatedNoShadowSocCatalogBusinessInd.id:
      case otpValidationPopupContent.separatedNoShadowSocTicket.id:
      case otpValidationPopupContent.separatedSaleDefaultPackage.id:
      case otpValidationPopupContent.separatedSaleAutoPackage.id:
      case otpValidationPopupContent.separatedSaleRollingPackage.id:
        activeTab = lobbyTabsEnum.BUSINESSACCOUNT;
        break;
      case otpValidationPopupContent.isNotGoldAccount.id:
      case otpValidationPopupContent.isNotRedOrFullFinAccount.id:
        activeTab = lobbyTabsEnum.BUSINESSINDIVIDUAL;
        props.setSearchedPackages(null);
        break;
      case otpValidationPopupContent.isPrivateAccount.id:
      case otpValidationPopupContent.isPrivateAccountInfo.id:
        activeTab = lobbyTabsEnum.PRIVATE;
        props.setSearchedPackages(null);
        break;
      case otpValidationPopupContent.isOrgEmployeeFamilyMember.id:
        activeTab = lobbyTabsEnum.PRIVATE;
        props.setSearchedPackages(null);
        approvedPopup = true;
        executePackagesSearch = true;
        break;
      default:
        break;
    }
    props.closeModal();
    props.saveToHistory();
    props.context.navigateTo(lobbyPath);
    props.returnToLobby({
      activeTab: activeTab,
      executePackagesSearch: executePackagesSearch,
      approvedPopup: approvedPopup,
    });
  };

  const checkIfDataIsOpenForCustomerAndAdd = () => {
    const businessOrPrivate =
      props.data.otpData.validatedCostumerData?.accountType == customerTypeEnum.BUSINESS
        ? customerTypeEnum.BUSINESS
        : customerTypeEnum.PRIVATE;

    if (props.data.epiStyleInitializationData.businessIndividualLobby) {
      gaSockRoamButtonClick(props.popupData.buttonText);
    } else {
      gaDefaultPackageContinueWithSelected(businessOrPrivate, props.data.startedFromPackage, props.popupData.buttonText);
    }
    if (
      (!props.data.epiStyleInitializationData.businessIndividualLobby && props.data.otpData.validatedCostumerData.subsriberSurfIsBlocked) ||
      (props.data.epiStyleInitializationData.businessIndividualLobby && props.data.businessIndividualData.closedForData)
    ) {
      props.openModal(popupReasonEnum.DATA_USAGE_IS_BLOCKED);
    } else if (
      !props.data.epiStyleInitializationData.businessIndividualLobby &&
      !props.data.otpData.validatedCostumerData.accountSegmentMatchSoc &&
      !props.data.otpData?.isFamilyProcess
    ) {
      props.openModal(popupReasonEnum.ACCOUNT_SEGMENT_MATCH_SOC);
    } else {
      if (!props.data.otpData?.isFamilyProcess) props.setReadyToPurchase(true);
      else props.setReadyToPurchaseFamily(true);
      closeModal();
    }
  };
  const defaultPackageWarningGAReport = (unSupportedCountriesSelectedPackage, suitableDatesSelectedPackage) => {
    const businessOrPrivate =
      props.data.otpData.validatedCostumerData?.accountType == customerTypeEnum.BUSINESS
        ? customerTypeEnum.BUSINESS
        : customerTypeEnum.PRIVATE;
    let eventParam = '';
    if (!suitableDatesSelectedPackage) {
      eventParam += ' .חבילה מסתיימת לפני התאריך שבחרת';
    }
    if (unSupportedCountriesSelectedPackage?.length > 0) {
      eventParam += ` .החבילה לא כוללת את מדינה/מדינות`;
    }
    if (businessOrPrivate == customerTypeEnum.PRIVATE) {
      if (props.data.startedFromPackage) {
        gaEvent(
          gaParams.ABROAD_TICKET_DEFAULT_PACKAGE_POPUP_WITH_WARNING_MESSAGE_PRIVATE_FROM_PACKAGE.category,
          gaParams.ABROAD_TICKET_DEFAULT_PACKAGE_POPUP_WITH_WARNING_MESSAGE_PRIVATE_FROM_PACKAGE.eventType,
          eventParam,
        );
      } else {
        gaEvent(
          gaParams.ABROAD_TICKET_DEFAULT_PACKAGE_POPUP_WITH_WARNING_MESSAGE_PRIVATE.category,
          gaParams.ABROAD_TICKET_DEFAULT_PACKAGE_POPUP_WITH_WARNING_MESSAGE_PRIVATE.eventType,
          eventParam,
        );
      }
    } else {
    }
  };

  const closeModal = () => {
    switch (props.popupData?.id) {
      case 'isCellcomWorkerOtpLobby':
        gaEvent(
          gaParams.ABROAD_LOBBY_OTP_VALIDATION_IS_CELLCOM_WORKER_THANKS_BUTTON_CLICK_BUSINESS.category,
          gaParams.ABROAD_LOBBY_OTP_VALIDATION_IS_CELLCOM_WORKER_THANKS_BUTTON_CLICK_BUSINESS.eventType,
          gaParams.ABROAD_LOBBY_OTP_VALIDATION_IS_CELLCOM_WORKER_THANKS_BUTTON_CLICK_BUSINESS.eventParams,
        );
        break;
      // case 'autoPackageExists':
      //   gaEvent(
      //     gaParams.ABROAD_LOBBY_OTP_VALIDATION_AUTO_PACKAGE_POPUP_BUTTON_CLICK_BUSINESS.category,
      //     gaParams.ABROAD_LOBBY_OTP_VALIDATION_AUTO_PACKAGE_POPUP_BUTTON_CLICK_BUSINESS.eventType,
      //     gaParams.ABROAD_LOBBY_OTP_VALIDATION_AUTO_PACKAGE_POPUP_BUTTON_CLICK_BUSINESS.eventParams
      //   );
      //   break;
      case 'autoPackageExistsBusinessIndividual':
        gaChangeAccountAutoPackage();
        break;
      case 'rollingPackageExists':
        gaEvent(
          gaParams.ABROAD_LOBBY_OTP_VALIDATION_ROLLING_PACKAGE_POPUP_BUTTON_CLICK_BUSINESS.category,
          gaParams.ABROAD_LOBBY_OTP_VALIDATION_ROLLING_PACKAGE_POPUP_BUTTON_CLICK_BUSINESS.eventType,
          gaParams.ABROAD_LOBBY_OTP_VALIDATION_ROLLING_PACKAGE_POPUP_BUTTON_CLICK_BUSINESS.eventParams,
        );
        break;
      case 'pricePlanVoiceExists':
        gaPricePlanVoiceExistsButtonClick();
        break;
      case 'customerGoldClass':
        gaCustomerGoldClassButtonClick();
        break;
      case 'abroadIsClosedForAccountBusinessIndividual':
        gaSockRoamButtonClick(props.popupData.buttonAsLinkText);
        break;

      default:
        break;
    }

    if (
      (props.data.otpData?.validatedCostumerData?.isSeparatedSale &&
        props.data.page == pages.SALE &&
        props.popupData.id != 'abroadIsClosedForAccountSeparatedByUse') ||
      ((props.popupData.id == 'isBusinessAccountInfo' || props.popupData.id == 'isBusinessAccount') && props.data.page == pages.SALE)
    ) {
      props.setSelectedAbroadPackage(null);
      returnToAbroadLobby();
    }
    if (props.data.otpData?.validatedCostumerData?.isSeparatedSale && isIOS && props.data.page == pages.LOBBY) {
      window.scrollTo(0, 0);
    }
    if (props.popupData.id == 'customerGoldClass' || props.popupData.id == 'pricePlanVoiceExists') {
      props.setLoading(true);
    }
    props.closeModal();
    props.saveToHistory();
  };
  function callbackGaReport() {
    gaEvent(
      gaParams.ABROAD_LOBBY_OTP_VALIDATION_CANT_PURCHASE_POPUP_CALLBACK_CLICK_BUSINESS.category,
      gaParams.ABROAD_LOBBY_OTP_VALIDATION_CANT_PURCHASE_POPUP_CALLBACK_CLICK_BUSINESS.eventType,
      gaParams.ABROAD_LOBBY_OTP_VALIDATION_CANT_PURCHASE_POPUP_CALLBACK_CLICK_BUSINESS.eventParams,
    );
  }
  function callbackSocRoamReport() {
    gaEvent(
      gaParams.ABROAD_LOBBY_OTP_VALIDATION_SOC_ROAM_POPUP_CALLBACK_CLICK_BUSINESS.category,
      gaParams.ABROAD_LOBBY_OTP_VALIDATION_SOC_ROAM_POPUP_CALLBACK_CLICK_BUSINESS.eventType,
      gaParams.ABROAD_LOBBY_OTP_VALIDATION_SOC_ROAM_POPUP_CALLBACK_CLICK_BUSINESS.eventParams,
    );
  }
  function gaOnOpenDefaultPackage() {
    gaEvent(
      gaParams.ABROAD_TICKET_DEFAULT_PACKAGE_POPUP_OPEN_EXISTS_PACKAGE_BUTTON_CLICK_BUSINESS.category,
      gaParams.ABROAD_TICKET_DEFAULT_PACKAGE_POPUP_OPEN_EXISTS_PACKAGE_BUTTON_CLICK_BUSINESS.eventType,
      gaParams.ABROAD_TICKET_DEFAULT_PACKAGE_POPUP_OPEN_EXISTS_PACKAGE_BUTTON_CLICK_BUSINESS.eventParams,
    );
  }
  function gaSeparatedSaleReport(popupId) {
    switch (popupId) {
      case 'abroadIsClosedForAccountSeparatedBank':
      case 'abroadIsClosedForAccountSeparatedByUse':
        gaEvent(
          gaParams.SEPARATED_BLOCKSOC_NOTICE.category,
          gaParams.SEPARATED_BLOCKSOC_NOTICE.eventType,
          gaParams.SEPARATED_BLOCKSOC_NOTICE.eventParams,
        );
        break;
      case 'separatedSaleDefaultPackage':
        gaEvent(
          gaParams.SEPARATED_DEFAULTSOC_NOTICE.category,
          gaParams.SEPARATED_DEFAULTSOC_NOTICE.eventType,
          gaParams.SEPARATED_DEFAULTSOC_NOTICE.eventParams,
        );
        break;
      case 'separatedSaleRollingPackage':
        gaEvent(
          gaParams.SEPARATED_ROLLINGSOC_NOTICE.category,
          gaParams.SEPARATED_ROLLINGSOC_NOTICE.eventType,
          gaParams.SEPARATED_ROLLINGSOC_NOTICE.eventParams,
        );
        break;
      case 'separatedSaleAutoPackage':
        gaEvent(
          gaParams.SEPARATED_AUTOMATICSOC_NOTICE.category,
          gaParams.SEPARATED_AUTOMATICSOC_NOTICE.eventType,
          gaParams.SEPARATED_AUTOMATICSOC_NOTICE.eventParams,
        );
        break;
      case 'separatedNoShadowSoc':
      case 'separatedNoShadowSocTicket':
      case 'separatedNoShadowSocCatalogBusinessInd':
        gaEvent(
          gaParams.SEPARATED_NOSHADOWSOC_NOTICE.category,
          gaParams.SEPARATED_NOSHADOWSOC_NOTICE.eventType,
          gaParams.SEPARATED_NOSHADOWSOC_NOTICE.eventParams,
        );
        break;
      case 'separatedGeneralError':
        gaEvent(
          gaParams.SEPARATED_GENERALERROR_NOTICE.category,
          gaParams.SEPARATED_GENERALERROR_NOTICE.eventType,
          gaParams.SEPARATED_GENERALERROR_NOTICE.eventParams,
        );
        break;
    }
  }

  const changeAccount = () => {
    gaChangeAccountAutoPackage();
    let params = {
      isSelecting: true,
      removeSelectedAbroadPackage: false,
    };
    props.setIsSelectingAccountBusinessIndividual(params);
    props.context.navigateTo(props.data.businessIndividualData.selfCareBlockUrl);
  };

  function getPopupContent() {
    if (props.data.otpData.validatedCostumerData?.isSeparatedSale) {
      gaSeparatedSaleReport(props.popupData.id);
    }
    let content;
    switch (props.popupData?.id) {
      case 'isNotCellcomAccount':
      case 'dummySubIndIsNull':
      case 'subStatusIsA':
      case 'talkmanAccount':
        return (
          <>
            <PopupDescriptionComponent description={props.popupData.descriptionBold} />
            <BtnSubmit text={props.popupData.buttonText} onclick={() => closeModal()} />
          </>
        );
      case 'isPrivateAccount':
        let isPrivateAccountDescriptionWithPhone = props.popupData.descriptionBold.replace('phoneNumber', props.data.otpData.otpPhone);
        return (
          <>
            <PopupDescriptionComponent description={isPrivateAccountDescriptionWithPhone} />
            <BtnSubmit text={props.popupData.buttonText} onclick={() => returnToAbroadLobby()} />
          </>
        );
      case 'isPrivateAccountInfo':
        let isPrivateAccountInfoDescriptionWithPhone = props.popupData.descriptionBold.replace('phoneNumber', props.data.otpData.otpPhone);
        return (
          <>
            <PopupDescriptionComponent description={isPrivateAccountInfoDescriptionWithPhone} />
            <BtnSubmit text={props.popupData.buttonText} onclick={() => closeModal()} />
          </>
        );
      case 'isBusinessAccount':
        let descriptionWithPhone = props.popupData.description.replace('phoneNumber', props.data.otpData.otpPhone);
        return (
          <>
            <PopupDescriptionComponent description={descriptionWithPhone} />
            <BtnSubmit text={props.popupData.buttonText} onclick={() => returnToAbroadLobby()} />
          </>
        );
      case 'isOrgEmployeeFamilyMember':
        let descriptionOrgEmployeeFamilyMember = props.popupData.description.replace('phoneNumber', props.data.otpData.otpPhone)
        .replace('orgName', props.data.otpData?.validatedCostumerData?.orgName || '');
        return (
          <>
            <PopupDescriptionComponent description={descriptionOrgEmployeeFamilyMember} />
            <BtnSubmit text={props.popupData.buttonText} onclick={() => returnToAbroadLobby()} />
          </>
        );
      case 'isBusinessAccountWithPrivateSubscribers':
          let descriptionBusinessWithPrivateSubscribers = props.popupData.description.replace('phoneNumber', props.data.otpData.otpPhone);
          return (
            <>
              <PopupDescriptionComponent description={descriptionBusinessWithPrivateSubscribers} />
              <BtnSubmit text={props.popupData.buttonText} onclick={() => returnToAbroadLobby()} />
              <PopupButtonAsLinkComponent
                text={props.popupData.textButton}
                onClick={() => { props.setFlightManager(null); props.setSaleOtpStep(saleOTPSteps.AFTER_INPUT); closeModal(); }}
              />
            </>
          );
      case 'isNotGoldAccount':
      case 'isNotRedOrFullFinAccount':
        return (
          <>
            <PopupDescriptionComponent description={props.popupData.description} />
            <BtnSubmit text={props.popupData.buttonText} onclick={() => returnToAbroadLobby()} />
          </>
        );
      case 'isBusinessAccountInfo':
        let descrWithPhone = props.popupData.description.replace('phoneNumber', props.data.otpData.otpPhone);
        return (
          <>
            <PopupDescriptionComponent description={descrWithPhone} />
            <BtnSubmit text={props.popupData.buttonText} onclick={() => closeModal()} />
          </>
        );
      case 'isCellcomWorkerOtpSale':
        return (
          <>
            <PopupDescriptionComponent description={props.popupData.description} />
            <BtnSubmit text={props.popupData.buttonText} onclick={() => returnToAbroadLobby()} />
          </>
        );
      case 'isCellcomWorkerOtpSaleFamily':
        return (
          <>
            <PopupDescriptionComponent description={props.popupData.description} />
            <BtnSubmit text={props.popupData.buttonText} onclick={() => closeModal()} />
          </>
        );
      case 'isCellcomWorkerOtpLobby':
        return (
          <>
            <PopupDescriptionComponent description={props.popupData.description} />
            <BtnSubmit text={props.popupData.buttonText} onclick={() => closeModal()} />
          </>
        );
      case 'autoPackageExists':
        return (
          <>
            <PopupDescriptionComponent boldDescription={props.popupData.descriptionBold} description={props.popupData.description} />
            <BtnSubmit text={props.popupData.buttonText} onclick={() => returnToAbroadLobby()} />
          </>
        );
      case 'autoPackageExistsBusinessIndividual':
        const linkButtonFunc = () => {
          if (props.data.page == pages.SALE) return changeAccount();
          return closeModal();
        };
        props.data.page == pages.LOBBY;
        return (
          <>
            <PopupDescriptionComponent boldDescription={props.popupData.descriptionBold} description={props.popupData.description} />
            <BtnSubmit text={props.popupData.buttonText} onclick={() => returnToAbroadLobby()} />
            <PopupButtonAsLinkComponent
              text={props.popupData.buttonAsLinkText}
              onClick={() => {
                linkButtonFunc();
              }}
            />
          </>
        );
      case 'rollingPackageExists':
        return (
          <>
            <PopupDescriptionComponent boldDescription={props.popupData.descriptionBold} description={props.popupData.description} />
            <BtnSubmit text={props.popupData.buttonText} onclick={() => closeModal()} />
          </>
        );
      case 'cantPurchasePackage':
        return (
          <>
            <PopupDescriptionComponent boldDescription={props.popupData.descriptionBold} />
            <Row style={{ marginTop: '-35px', marginBottom: '25px' }}>
              <Col>לבירורים אפשר להתקשר למוקד השירות שלנו</Col>
            </Row>
            <CallBackComponent
              isBusiness={props.data.page == pages.LOBBY}
              onclick={props.data.page == pages.LOBBY ? () => callbackGaReport() : null}
            />
          </>
        );
      case 'unableToViewInformation':
        return (
          <>
            <PopupDescriptionComponent boldDescription={props.popupData.descriptionBold} />
            <CallBackComponent
              isBusiness={props.data.page == pages.LOBBY}
              onclick={props.data.page == pages.LOBBY ? () => callbackGaReport() : null}
            />
          </>
        );
      case 'abroadIsClosedForAccount':
        return (
          <>
            <PopupDescriptionComponent boldDescription={props.popupData.descriptionBold} />
            <CallBackComponent
              isBusiness={props.data.page == pages.LOBBY}
              onclick={props.data.page == pages.LOBBY ? () => callbackSocRoamReport() : null}
            />
          </>
        );
      case 'abroadIsClosedForAccountSeparatedBank':
        return (
          <>
            <PopupDescriptionComponent boldDescription={props.popupData.descriptionBold} />
            <PopupDescriptionComponent description={props.popupData.description} />
            <BtnSubmit
              text={'הבנתי'}
              onclick={() => {
                closeModal();
              }}
            />
          </>
        );
      case 'abroadIsClosedForAccountSeparatedByUse':
        return (
          <>
            <PopupDescriptionComponent boldDescription={props.popupData.descriptionBold} />
            <PopupDescriptionComponent description={props.popupData.description} />
            <BtnSubmit
              text={'הבנתי, אמשיך עם החבילה'}
              onclick={() => {
                props.context.navigateTo(props.data.epiStyleInitializationData.urlToSeparatedSale);
              }}
            />
            <div className='btn-white-Container' style={{ marginTop: '24px' }}>
              <button
                style={{ height: '50px', width: '290px' }}
                className='btn-white'
                onClick={() => {
                  props.setSelectedAbroadPackage(null);
                  if (props.data.page == pages.SALE) {
                    returnToAbroadLobby();
                  } else {
                    closeModal();
                  }
                }}>
                <span className='btn-white-text' style={{ fontSize: '1rem' }}>
                  תודה, אבחר חבילה אחרת
                </span>
              </button>
            </div>
          </>
        );
      case 'separatedSaleDefaultPackage':
      case 'separatedSaleRollingPackage':
      case 'separatedSaleAutoPackage':
        return (
          <>
            <PopupDescriptionComponent boldDescription={props.popupData.descriptionBold} />
            <PopupDescriptionComponent description={props.popupData.description} />
            <BtnSubmit
              text={'אוקיי'}
              onclick={() => {
                closeModal();
              }}
            />
          </>
        );
      case 'abroadIsClosedForAccountBusinessIndividual':
        const description = props.popupData.description.replace('phoneNumber', props.data.businessIndividualData.selectedAccountNumber);
        return (
          <>
            <PopupDescriptionComponent description={description} />
            <BtnSubmit text={props.popupData.buttonText} onclick={() => checkIfDataIsOpenForCustomerAndAdd()} />
            <PopupButtonAsLinkComponent
              text={props.popupData.buttonAsLinkText}
              onClick={() => {
                closeModal();
              }}
            />
          </>
        );
      case 'otpGeneralError':
        return (
          <>
            <PopupDescriptionComponent boldDescription={props.popupData.descriptionBold} />
            <CallBackComponent onclick={props.data.page == pages.LOBBY ? () => callbackGaReport() : null} />
          </>
        );
      case 'defaultPackageExists':
        let boldDescription = props.popupData.descriptionBold.replace(
          'phoneNumber',
          !props.data.otpData?.isFamilyProcess ? props.data.otpData.otpPhone : props.data.otpDataChildren.otpPhone,
        );
        let suitableDatesDefaultPackage = true;
        let unSupportedCountriesDefaultPackage = null;
        let suitableDatesSelectedPackage = isSuitableDates(
          props.data.selectedAbroadPackage,
          props.data.dates.datePickerStartJSFormat,
          props.data.dates.datePickerEndJSFormat,
        );
        let unSupportedCountriesSelectedPackage = getFilteredCountryList(
          props.data.selectedCountries,
          props.data.selectedAbroadPackage.countrySupportedList,
        );
        if (props?.data?.otpData?.isFamilyProcess) {
          if (props.data.otpDataChildren.defaultSOC?.details) {
            suitableDatesDefaultPackage = isSuitableDates(
              props.data.otpDataChildren.defaultSOC?.details,
              props.data.dates.datePickerStartJSFormat,
              props.data.dates.datePickerEndJSFormat,
            );
            unSupportedCountriesDefaultPackage = props.data.otpDataChildren.defaultSOC?.details?.countrySupportedList?.length
              ? getFilteredCountryList(props.data.selectedCountries, props.data.otpDataChildren.defaultSOC.details.countrySupportedList)
              : null;
          }
        } else {
          if (props.data.otpData.defaultSOC?.details) {
            suitableDatesDefaultPackage = isSuitableDates(
              props.data.otpData.defaultSOC?.details,
              props.data.dates.datePickerStartJSFormat,
              props.data.dates.datePickerEndJSFormat,
            );
            unSupportedCountriesDefaultPackage = props.data.otpData.defaultSOC?.details?.countrySupportedList?.length
              ? getFilteredCountryList(props.data.selectedCountries, props.data.otpData.defaultSOC.details.countrySupportedList)
              : null;
          }
        }
        return (
          <>
            <PopupDescriptionComponent boldDescription={boldDescription} />
            <PopupDefaultPackageDataComponent
              unsupportedCountries={unSupportedCountriesDefaultPackage?.length > 0 ? unSupportedCountriesDefaultPackage : null}
              isSuitableDates={suitableDatesDefaultPackage}
              isBusiness={props.data.otpData.validatedCostumerData.accountType != customerTypeEnum.PRIVATE}
              selectedPackage={props.data.selectedAbroadPackage}
              supportedApps={props.data.getEpiGeneralData.supportedApps}
              defaultSOC={
                !props.data.otpData?.isFamilyProcess
                  ? props.data.otpData?.validatedCostumerData?.isSeparatedSale
                    ? props.data.otpData.validatedCostumerData.isDefaultSoc.find((defPackage) => defPackage.alretPopUpToUser == true)
                    : props.data.otpData.defaultSOC.details
                  : props.data.otpDataChildren.defaultSOC.details
              }
              context={props.context}
              gaOnOpenDefaultPackage={
                props.data.otpData.validatedCostumerData.accountType != customerTypeEnum.PRIVATE ? gaOnOpenDefaultPackage : null
              }
            />
            <div className='default-package-popup-selected_package'>
              <Row>
                <Col className='defaultSOC-title bold text-center'>
                  כדי שתוכלו להשוות,
                  <br /> זו חבילת חו"ל החדשה שבחרתם:
                </Col>
              </Row>
              <AbroadPackageTab
                packageData={props.data.selectedAbroadPackage}
                supportedApps={props.data.getEpiGeneralData.supportedApps}
                context={props.context}
              />
              {(unSupportedCountriesSelectedPackage?.length > 0 || !suitableDatesSelectedPackage) && (
                <WarningMessageComponent
                  unsupportedCountries={unSupportedCountriesSelectedPackage}
                  isSuitableDates={suitableDatesSelectedPackage}
                  isBusiness={props.data.otpData.validatedCostumerData.accountType == customerTypeEnum.BUSINESS}
                  gaReport={() => defaultPackageWarningGAReport(unSupportedCountriesSelectedPackage, suitableDatesSelectedPackage)}
                />
              )}
            </div>
            <BtnSubmit text={props.popupData.buttonText} onclick={() => checkIfDataIsOpenForCustomerAndAdd()} />
            <PopupButtonAsLinkComponent
              text={!props.data?.otpData?.isFamilyProcess ? `להישאר עם החבילה שכבר יש לי` : `נשאר עם החבילה הקיימת`}
              onClick={() => {
                let reportParams = getReportParams();
                reportParams.area = 'SelfCare';
                reportParams.subArea = 'Cellcom Abroad';
                reportParams.channel =
                  props.data.activeLobbyTab && props.data.activeLobbyTab == 'businessAccount' ? 'WebsiteBusiness' : 'WebsitePrivate';
                reportParams.actionType = 'Stayed with default package';
                reportParams.status = 'Ongoing';
                reportParams.messageText = 'Client chose to stay with his default package';
                reportParams.subscriber = props.data.otpData.otpPhone ? props.data.otpData.otpPhone : '';
                reportParams.param1 = 'WEBSITE';
                if (props.data.isJETAuthentication) {
                  reportParams.param1 = 'JET';
                }
                if (props.data.selectedAbroadPackage?.isFamilyBonus) {
                  reportParams.param3 =
                    props.data.selectedAbroadPackage.isGiveFamilyBonus || props.data.selectedAbroadPackage.isFamilyBonus
                      ? 'בני משפחות'
                      : '';
                  reportParams.param4 = 'מספר מנוי ראשי - ' + props.data.otpData.otpPhone;
                  reportParams.subscriber = props.data.otpDataChildren ? props.data.otpDataChildren.otpPhone : '';
                }
                report(reportParams);
                if (props.data.otpData?.isFamilyProcess) props.closeModal({ isDefaultSocFromFamily: true });
                else returnToAbroadLobby();
              }}
            />
          </>
        );
      case 'separatedNoShadowSoc':
      case 'separatedNoShadowSocTicket':
      case 'separatedNoShadowSocCatalogBusinessInd':
      case 'customerGoldClass':
      case 'pricePlanVoiceExists':
      case 'separatedGeneralError':
      case 'basicGeneralError':
      case 'addonPurchaseSucceeded':
      case 'addonPurchaseFault':
        return (
          <>
            {props.popupData.subTitle && <PopupSubTitleComponent subTitle={props.popupData.subTitle} />}
            {props.popupData.description && <PopupDescriptionComponent description={props.popupData.description} />}
            {props.popupData.buttonText && <BtnSubmit text={props.popupData.buttonText} onclick={() => closeModal()} />}
            {props.popupData.bottomComponent && <CallBackComponent />}
          </>
        );
    }
    return content;
  }
  return (
    <Container className={`${props.popupData.id == 'defaultPackageExists' ? 'defaultPackageExists' : ''}`}>
      {props.popupData.headline && <PopupHeadlineComponent title={props.popupData.headline} />}
      {props.popupData.id != 'defaultPackageExists' && (
        <>
          {props.popupData.animated ? (
            <ThemedLottie animationData={PaperPlane} color={ThemeColorEnum.PRIMARY} loop={false} width={250} />
          ) : (
            <PopupImageComponent icon={props.popupData.icon} animated={props.popupData.animated} />
          )}
        </>
      )}
      {currentPopupContent}
    </Container>
  );
};
const mapStateToProps = (state) => {
  return {
    data: state.cellcomAbroad,
    authentication: state.authentication,
  };
};
const mapDispatchToProps = {
  removeOtpData,
  resetAuth,
  resetLoginData,
  saveToHistory,
  closeModal,
  openModal,
  setActiveLobbyTab,
  returnToLobby,
  setRemoveToCustomerSurfingBlockage,
  setReadyToPurchase,
  setSelectedAbroadPackage,
  setReadyToPurchaseFamily,
  setIsSelectingAccountBusinessIndividual,
  setSearchedPackages,
  setLoading,
  setFlightManager,
  setSaleOtpStep,
};
export default connect(mapStateToProps, mapDispatchToProps)(OtpValidationResultPopupConstructor);
